<template>
  <v-card class="mx-auto pb-6" outlined>
    <v-row no-gutters>
      <v-col cols="12" class="px-4 pt-5 pb-2">
        <div class="pr-8 mb-4 text-left section-title">Ordenar</div>
        <v-select
          v-model="filter.order"
          :items="orderList"
          item-text="name"
          item-value="key"
          label="Ordenar"
          @change="searchProducts"
          filled
          dense>
        </v-select>
      </v-col>
      <v-col cols="12" class="card-border-top px-4 pt-5 pb-2">
        <v-row no-gutters>
          <v-col>
            <div class="mb-4 text-left section-title">Filtros</div>
          </v-col>
          <v-col v-if="$vuetify.breakpoint.xsOnly && isFiltered">
            <a @click="clearFilters">
              <div class="text-right mb-4 text-left clear-filter-title">Limpiar</div>
            </a>
          </v-col>
        </v-row>
        <div v-if="isFiltered">
          <v-list subheader dense>
            <v-list-item-group>
              <div v-if="filteredByBrand">
                <v-list-item class="text-left" v-for="(brand, index) in brands" :key="'brand_' + brand.name">
                  <v-list-item-content>
                    <v-list-item-title v-text="brand.name"></v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-icon>
                    <v-icon class="filter-close-icon" @click="deleteBrand(index)">
                      mdi-close
                    </v-icon>
                  </v-list-item-icon>
                </v-list-item>
              </div>
              <v-list-item class="text-left" v-if="filteredByCondition">
                <v-list-item-content>
                  <v-list-item-title v-text="getCondition(filter.condition)"></v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-icon class="filter-close-icon" @click="deleteCondition()">
                    mdi-close
                  </v-icon>
                </v-list-item-icon>
              </v-list-item>

              <v-list-item class="text-left" v-if="filteredByMinPrice || filteredByMaxPrice">
                <v-list-item-content>
                  <v-list-item-title>
                    <span v-if="filteredByMinPrice &&filteredByMaxPrice">{{ currency(filter.min_price) }} a {{ currency(filter.max_price) }}</span>
                    <span v-else-if="filteredByMaxPrice">Hasta {{ currency(filter.max_price) }}</span>
                    <span v-else-if="filteredByMinPrice">Más de {{ currency(filter.min_price) }}</span>
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-icon class="filter-close-icon" @click="deletePrice()">
                    mdi-close
                  </v-icon>
                </v-list-item-icon>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </div>
        <div class="mb-7" v-if="!filteredByBrand">
          <div class="pr-8 text--primary text-left font-weight-light">Marcas</div>
          <v-checkbox class="mb-n2" v-for="brand in brands"
            :key="'brand_' + brand.name"
            v-model="selectedBrands"
            :label="brand.name"
            :value="brand.name"
            color="blue"
            hide-details>
            <template v-slot:label>
              <div class="body-2">{{brand.name}}<span style="color: #999999">&nbsp;({{brand.count}})</span></div>
            </template>
          </v-checkbox>
        </div>
        <div class="mb-7" v-if="!filteredByCondition">
          <div class="pr-8 text--primary text-left font-weight-light">Estado</div>
          <v-checkbox class="mb-n2" v-for="condition in conditions"
            :key="'condition_' + condition.id"
            v-model="selectedCondition"
            :label="condition.name"
            :value="condition.name"
            color="blue"
            hide-details>
            <template v-slot:label>
              <div class="body-2 grey--text text--darken-1">{{getCondition(condition.name)}}<span style="color: #999999">&nbsp;({{condition.count}})</span></div>
            </template>
          </v-checkbox>
        </div>
        <div class="mb-7" v-if="!filteredByPrice">
          <div class="pr-8 text--primary text-left font-weight-light">Precio</div>
          <v-range-slider class="mt-1 mb-2" v-model="priceRange" :max="price.max" :min="price.min" hide-details></v-range-slider>
          <v-row no-gutters>
            <v-col class="mr-1">
              <vuetify-money v-model="minPrice" label="Mín" :options="moneyOptions" outlined dense hide-details />
            </v-col>
            <v-col class="ml-1">
              <vuetify-money v-model="maxPrice" label="Máx" :options="moneyOptions" outlined dense hide-details />
            </v-col>
          </v-row>
        </div>
      </v-col>
      <v-col cols="12" class="px-4" v-if="!isAllFiltered">
        <!-- :loading="loading" @click="submit"-->
        <v-btn class="text-none btn-apply" depressed large @click="searchProducts">
          Aplicar Filtros
        </v-btn>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import Vue from 'vue'
import { mapState } from 'vuex'
import { ORDER_LIST } from '@/shared/order'
import { getCondition } from '@/shared/condition'
import { cloneObject } from '@/shared/clone'
import { currency } from '@/shared/format'

export default {
  name: 'FilterProducts',
  props: {
    brands: {
      type: Array,
      required: true
    },
    conditions: {
      type: Array,
      required: true
    },
    price: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      getCondition,
      currency,
      orderList: ORDER_LIST,
      order: 'score',
      selectedBrands: [],
      selectedCondition: null,
      priceRange: [],
      minPrice: 0,
      maxPrice: 0,
      moneyOptions: {
        locale: 'es-CO',
        prefix: '$',
        precision: 0
      },
      filter: {}
    }
  },
  computed: {
    ...mapState('product', ['searchConfig']),
    filteredByBrand () {
      return !!this.filter.brands && this.filter.brands.length > 0
    },
    filteredByCondition () {
      return !!this.filter.condition
    },
    filteredByMinPrice () {
      return !!this.filter.min_price
    },
    filteredByMaxPrice () {
      return !!this.filter.max_price
    },
    filteredByPrice () {
      return this.filteredByMinPrice || this.filteredByMaxPrice
    },
    isFiltered () {
      return this.filteredByBrand || this.filteredByCondition || this.filteredByMinPrice || this.filteredByMaxPrice
    },
    isAllFiltered () {
      return this.filteredByBrand && this.filteredByCondition && (this.filteredByMinPrice || this.filteredByMaxPrice)
    }
  },
  methods: {
    initFilter () {
      this.filter = cloneObject(this.searchConfig)
      if (!('order' in this.filter)) {
        Vue.set(this.filter, 'order', 'score')
      }

      if (!('brands' in this.filter)) {
        Vue.set(this.filter, 'brands', [])
      }

      const brands = this.filter.brands
      if (brands) {
        this.selectedBrands = brands
      }

      const condition = this.filter.condition
      if (condition) {
        this.selectedCondition = condition
      }

      const selectedMinPrice = this.getSelectedPrice(this.filter.min_price, this.price.min)
      const selectedMaxPrice = this.getSelectedPrice(this.filter.max_price, this.price.max)

      Vue.set(this.price, 'max', selectedMaxPrice)

      this.priceRange = [selectedMinPrice, selectedMaxPrice]
      this.minPrice = selectedMinPrice
      this.maxPrice = selectedMaxPrice
    },
    getSelectedPrice (price, defaultPrice) {
      return price || defaultPrice
    },
    searchProducts () {
      const filter = this.buildFilter()

      this.$emit('filterProducts', filter)
    },
    buildFilter () {
      const filter = cloneObject(this.filter)
      if (this.orderShouldBeRemoved(filter.order)) {
        delete filter.order
      }

      filter.brands = this.selectedBrands
      if (this.brandsFilterShouldBeRemoved(filter.brands)) {
        delete filter.brands
      }

      filter.condition = this.selectedCondition
      if (!filter.condition) {
        delete filter.condition
      }

      filter.min_price = this.minPrice

      this.priceFilterShouldBeRemoved(filter.min_price, this.price.min)
      if (this.priceFilterShouldBeRemoved(filter.min_price, this.price.min)) {
        delete filter.min_price
      }

      filter.max_price = this.maxPrice
      if (this.priceFilterShouldBeRemoved(filter.max_price, this.price.max)) {
        delete filter.max_price
      }

      return filter
    },
    orderShouldBeRemoved (order) {
      return order && order === 'score'
    },
    brandsFilterShouldBeRemoved (brands) {
      return brands && brands.length === 0
    },
    priceFilterShouldBeRemoved (price, currentPrice) {
      return price && price === currentPrice
    },
    deleteBrand (index) {
      const filter = this.buildFilter()

      if (Array.isArray(filter.brands)) {
        filter.brands.splice(index, 1)
        this.$emit('filterProducts', filter)
        return
      }

      delete filter.brands
      this.$emit('filterProducts', filter)
    },
    deleteCondition () {
      const filter = this.buildFilter()
      delete filter.condition

      this.$emit('filterProducts', filter)
    },
    deletePrice () {
      const filter = this.buildFilter()
      if (filter.min_price) {
        delete filter.min_price
      }

      if (filter.max_price) {
        delete filter.max_price
      }

      this.$emit('filterProducts', filter)
    },
    clearFilters () {
      const filter = this.buildFilter()

      if (filter.brands) {
        delete filter.brands
      }

      if (filter.condition) {
        delete filter.condition
      }

      if (filter.min_price) {
        delete filter.min_price
      }

      if (filter.max_price) {
        delete filter.max_price
      }

      this.$emit('filterProducts', filter)
    }
  },
  mounted () {
    this.initFilter()
  },
  watch: {
    priceRange: function (range) {
      if (this.minPrice !== range[0]) {
        this.minPrice = range[0]
        this.filter.min_price = range[0]
        return
      }

      if (this.maxPrice !== range[1]) {
        this.maxPrice = range[1]
        this.filter.max_price = range[1]
      }
    },
    minPrice: function (min) {
      if (this.priceRange && this.priceRange[0] !== min) {
        this.priceRange = [min, this.priceRange[1]]
      }
    },
    maxPrice: function (max) {
      if (this.priceRange && this.priceRange[1] !== max) {
        this.priceRange = [this.priceRange[0], max]
      }
    }
  }
}
</script>
<style scoped>
.count {
  color: #999999;
}
.v-list-item {
  padding: 0 0.25rem;
}
.filter-close-icon {
  font-size: 1rem;
}
.clear-filter-title{
  font-size: 1em !important;
  font-weight: 500;
}
.btn-apply {
  width: 100%;
  background-color: #1E88E5 !important;
  color: #FFFFFF;
}
</style>
